// HeroSection.js
import React from 'react';
import './css/HeroSection.css';
import Navbar from "../components/Navbar";

const HeroSection = () => {
  return (
    <>
    <Navbar/>
    <section className="hero">
      <div className="hero-overlay" />
      <div className="hero-content">
        <h1 className="hero-title">Explore the Wild</h1>
        <p className="hero-subtitle">
          Journey deep into Africa’s most breathtaking landscapes with personalized safari tours.
        </p>
        <div className="hero-buttons">
          <a href='/trips' className="hero-btn primary">Explore Tours</a>
          <a href='/quotation' className="hero-btn secondary">Get Quotation</a>
        </div>
      </div>
    </section>
    </>
  );
};

export default HeroSection;
